module.exports = __webpack_public_path__ + "media/images/map-b3d7962a4effc1aa3144581d97386f3b.png";